import store from '@/store'

export default [
  {
    path: '/leave-records',
    name: 'leave-record',
    meta: { requiresAuth: true },
    component: () => import('@/pages/leave-record/index.vue')
  },
  {
    path: '/leave-records/create',
    name: 'leave-record-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/leave-record/create.vue')
  },
  {
    path: '/leave-records/:id',
    name: 'leave-record-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/leave-record/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('leaveRecord/find', to.params.id)
      next()
    }
  }
]
